import {
    ACCESS_PAGE,
    API_INTEGRATION_PAGE,
    CLIENT_PAGE,
    CONCESSIONS_PAGE,
    CONTINGENCIA_PAGE,
    CURVES_DTS_PAGE,
    CURVES_PAGE,
    CURVES_SETORIAL_PAGE,
    CURVES_SPREAD_PAGE,
    CURVES_SUBSETORIAL_PAGE,
    CURVES_TIR_PAGE,
    CUSTOMERS_PRICE_LOG_PAGE,
    DELETE_DATA_PAGE,
    EMISSAO_PAGE,
    EMISSAO_V2_PAGE,
    EMPRESAS_PAGE,
    FIXED_INCOME_CALCULATOR_PAGE,
    HOME_PAGE,
    IMPORT_PAGE,
    INTEGRATION_DATA_PAGE,
    LOGOUT_PAGE,
    MARKET_RATES_PAGE, MEMORIA_DE_CALCULO,
    METHODOLOGY_PAGE, MOTOR_CADASTRO_PAGE, MOTOR_EVENTOS_PAGE,
    STATUS_CADASTRO_PAGE,
    MOTOR_CADASTRO_LOTE_PAGE,
    PARAMETERS_CALC_PAGE,
    PARAMETERS_DATALAKE_PAGE,
    PARAMETERS_PAGE,
    PRICES_PAGE,
    PRICES_TABLE_BONDS_PAGE,
    PRICES_UPDATE_SPREADS,
    PRODUCT_PAGE,
    PROFILE_PAGE,
    PROMPT_PAGE,
    RATER_CALCULADORA_PAGE,
    RATER_CONFIGURACOES_PAGE,
    RATER_HISTORICO_PAGE,
    RATER_MERTON_PAGE,
    RATER_RELATORIO_PAGE,
    RATER_SETORIAL_PAGE,
    SIMULADOR_SUBORDINACAO_PAGE,
    SUPPORT_PAGE,
    USER_PAGE,
    WALLETS_PAGE,
    DESIGN_SYSTEM_PAGE,
    TREINAMENTO_MERCADO_PAGO_PAGE,
    TRATAMENTO_SPREADS_PAGE,
} from "../../../../utils/routes"

export const MENU_ITEMS = [
    { label: "Home", route: HOME_PAGE },
    {
        label: "ACESSO",
        isAdmin: true,
        id: "menu_acesso",
        children: [
            {
                label: "Clientes",
                route: CLIENT_PAGE,
                isAdmin: true,
                id: "menu_acesso_clientes",
            },
            {
                label: "Usuários",
                route: USER_PAGE,
                isAdmin: true,
                id: "menu_acesso_usuarios",
            },
            {
                label: "Produtos",
                route: PRODUCT_PAGE,
                isAdmin: true,
                id: "menu_acesso_produtos",
            },
            {
                label: "Grupos",
                route: ACCESS_PAGE,
                isAdmin: true,
                id: "menu_acesso_grupos",
            },
            {
                label: "Trilhas de Auditoria",
                route: "#",
                isAdmin: true,
                id: "menu_acesso_trilhas",
            },
        ],
    },
    {
        label: "CREDIT CALC",
        isAdmin: false,
        id: "menu_calc",
        children: [
            {
                label: "Parâmetros",
                route: PARAMETERS_CALC_PAGE,
                isAdmin: false,
                id: "menu_calc_parametros",
            },
            {
                label: "Tratamento Spreads",
                route: TRATAMENTO_SPREADS_PAGE,
                isAdmin: true,
                id: "menu_calc_tratamento",
            },
            {
                label: "Contigência",
                route: CONTINGENCIA_PAGE,
                isAdmin: false,
                id: "menu_calc_contigencia",
            },
            {
                label: "Processos",
                route: "#",
                isAdmin: false,
                id: "menu_calc_processos",
            },
        ],
    },
    {
        label: "GESTOR DE RECEBÍVEIS",
        isAdmin: false,
        id: "menu_gr",
        children: [
            {
                label: "Concessões",
                route: CONCESSIONS_PAGE,
                isAdmin: false,
                id: "menu_gr_operacoes",
            },
            {
                label: "Carteiras",
                route: WALLETS_PAGE,
                isAdmin: false,
                id: "menu_gr_carteiras",
            },
            {
                label: "Simulador Subordinação",
                route: SIMULADOR_SUBORDINACAO_PAGE,
                isAdmin: false,
                id: "menu_gr_simulador_subordinacao",
            },
            {
                label: "Taxas de Mercado",
                route: MARKET_RATES_PAGE,
                isAdmin: false,
                id: "menu_gr_taxas",
            },
            {
                label: "Parâmetros",
                route: PARAMETERS_PAGE,
                isAdmin: true,
                id: "menu_gr_parametros",
            },
        ],
    },
    {
        label: "RATER",
        isAdmin: false,
        id: "menu_rater",
        children: [
            {
                label: "Calculadora",
                route: RATER_CALCULADORA_PAGE,
                isAdmin: false,
                id: "menu_rater_calculadora",
            },
            {
                label: "Histórico de Rating",
                route: RATER_HISTORICO_PAGE,
                isAdmin: false,
                id: "menu_rater_historico",
            },
            {
                label: "Merton's Model",
                route: RATER_MERTON_PAGE,
                isAdmin: false,
                id: "menu_rater_merton",
            },
            {
                label: "Relatório de Rating",
                route: RATER_RELATORIO_PAGE,
                isAdmin: false,
                id: "menu_rater_relatorio",
            },
            {
                label: "Setorial",
                route: RATER_SETORIAL_PAGE,
                isAdmin: false,
                id: "menu_rater_setorial",
            },
            {
                label: "Configurações",
                route: RATER_CONFIGURACOES_PAGE,
                isAdmin: false,
                id: "menu_rater_configurações",
            },
        ],
    },
    {
        label: "CURVAS",
        isAdmin: false,
        id: "menu_curvas",
        children: [
            {
                label: "Tabela de Curvas",
                route: CURVES_PAGE,
                isAdmin: false,
                id: "menu_curvas_tabela",
            },
            {
                label: "Curvas ETTJC",
                route: CURVES_TIR_PAGE,
                isAdmin: false,
                id: "menu_curvas_tir",
            },
            {
                label: "Curvas de Spread",
                route: CURVES_SPREAD_PAGE,
                isAdmin: false,
                id: "menu_curvas_spread",
            },
            {
                label: "Curvas Setoriais",
                route: CURVES_SETORIAL_PAGE,
                isAdmin: false,
                id: "menu_curvas_setoriais",
            },
            {
                label: "Curva Subsetoriais",
                route: CURVES_SUBSETORIAL_PAGE,
                isAdmin: false,
                id: "menu_curvas_subsetoriais",
            },
            {
                label: "Curva de DTS",
                route: CURVES_DTS_PAGE,
                isAdmin: false,
                id: "menu_curvas_dts",
            },
        ],
    },
    {
        label: "PREÇOS",
        isAdmin: false,
        id: "menu_precos",
        children: [
            {
                label: "Tabela de PU/TIR",
                route: PRICES_PAGE,
                isAdmin: false,
                id: "menu_precos_tabela",
            },
            {
                label: "Tabela de PU/Bonds",
                route: PRICES_TABLE_BONDS_PAGE,
                isAdmin: false,
                id: "menu_precos_tabela_bonds",
            },
            {
                label: "Memória de Cálculo",
                route: MEMORIA_DE_CALCULO,
                isAdmin: false,
                id: "menu_precos_memoria_calculo",
            },
            {
                label: "Atualização de Spreads",
                route: PRICES_UPDATE_SPREADS,
                isAdmin: false,
                id: "menu_precos_atualizacao_spreads",
            },
            {
                label: "Preços Log",
                route: CUSTOMERS_PRICE_LOG_PAGE,
                isAdmin: false,
                id: "menu_precos_clientes_log",
            },
        ],
    },
    {
        label: "CALCULADORA",
        isAdmin: false,
        id: "menu_calculadora",
        children: [
            {
                label: "Títulos Privados",
                route: FIXED_INCOME_CALCULATOR_PAGE,
                isAdmin: false,
                id: "menu_calculadora_calculadora_renda_fixa",
            },
        ],
    },
    {
        label: "DATA LAKE",
        isAdmin: false,
        id: "menu_data_lake",
        children: [
            {
                label: "Emissão",
                route: EMISSAO_PAGE,
                isAdmin: false,
                id: "menu_data_lake_emissao",
            },
            {
                label: "Empresas",
                route: EMPRESAS_PAGE,
                isAdmin: false,
                id: "menu_data_lake_empresas",
            },
            {
                label: "Consulta de Dados",
                route: PARAMETERS_DATALAKE_PAGE,
                isAdmin: false,
                id: "menu_data_lake_consulta_dados",
            },
            {
                label: "Integração Dados Externos",
                route: INTEGRATION_DATA_PAGE,
                isAdmin: false,
                id: "menu_data_lake_market_data",
            },
            {
                label: "Importação de Dados",
                route: IMPORT_PAGE,
                isAdmin: false,
                id: "menu_data_lake_importacao_dados",
            },
            {
                label: "Exclusão de Dados",
                route: DELETE_DATA_PAGE,
                isAdmin: false,
                id: "menu_data_lake_exclusao_dados",
            },
            {
                label: "Prompts",
                route: PROMPT_PAGE,
                isAdmin: true,
                id: "menu_data_lake_prompts",
            },                        
            {
                label: "Emissão 2",
                route: EMISSAO_V2_PAGE,
                isAdmin: false,
                id: "menu_data_lake_emissao_v2"
            },
        ],
    },
    {
        label: "CADASTRO",
        isAdmin: false,
        id: "menu_motor",
        children: [
            {
                label: "Características",
                route: MOTOR_CADASTRO_PAGE,
                isAdmin: true,
                id: "menu_motor_cadastro",
            },
            {
                label: "Eventos",
                route: MOTOR_EVENTOS_PAGE,
                isAdmin: true,
                id: "menu_motor_cadastro_eventos",
            },
            {
                label: "Status",
                route: STATUS_CADASTRO_PAGE,
                isAdmin: true,
                id: "menu_motor_status_cadastro",
            },
            {
                label: "Lote",
                route: MOTOR_CADASTRO_LOTE_PAGE,
                isAdmin: true,
                id: "menu_motor_cadastro_lote",
            }
        ],
    },
    {
        label: "TREINAMENTO",
        isAdmin: false,
        id: "menu_treinamento",
        children: [
            {
                label: "Mercado Pago",
                route: TREINAMENTO_MERCADO_PAGO_PAGE,
                isAdmin: false,
                id: "menu_treinamento_mercado_pago",
            },
        ]
    },
    {
        label: "CONFIGURAÇÕES",
        isAdmin: false,
        id: null,
        children: [
            {
                label: "Perfil do Usuário",
                route: PROFILE_PAGE,
                isAdmin: false,
                id: null,
            },
            {
                label: "Suporte",
                route: SUPPORT_PAGE,
                isAdmin: false,
                id: "menu_config_suporte",
            },
            {
                label: "Metodologia",
                route: METHODOLOGY_PAGE,
                isAdmin: false,
                id: "menu_config_metodologia",
            },
            {
                label: "Design System",
                route: DESIGN_SYSTEM_PAGE,
                isAdmin: true,
                id: "menu_config_design_system",
            },
            {
                label: "API Integração",
                route: API_INTEGRATION_PAGE,
                isAdmin: false,
                id: "menu_config_api",
            },
            { label: "Sair", route: LOGOUT_PAGE, isAdmin: false, id: null },
        ],
    },
]
